import { exec } from "@kakaopay-common/payweb-core";
import { INTERFACE } from "../../constants.mjs";
function getUuid() {
  const command = {
    command: INTERFACE.UUID
  };
  return new Promise((resolve, reject) => {
    exec(command).then((res) => {
      const uuidResult = { ...res };
      if (res.success) {
        const result = /window.WAVE.uuidCallback\('([^)]+)'\)/.exec(res.result.uuid);
        if (result) {
          uuidResult.result.uuid = result[1];
        }
      }
      resolve(uuidResult);
    }).catch((err) => {
      reject(err);
    });
  });
}
export {
  getUuid
};
